import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    marginBottom: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },

  title: {
    marginBottom: '5px',
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  content: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: '16px'
  },

  item: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '4px',
    marginRight: '4px',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '100rem',
    padding: '6px 10px',
    background: '#F8D8FF',
    fontSize: theme.size.sm,
    color: theme.palette.primary.main,
    userSelect: 'none',

    '&:last-child': {
      marginRight: '0'
    }
  },

  name: {
    marginBottom: '8px',
    fontSize: theme.size.base,
    color: '#1F1F1F'
  },

  input: {
    marginBottom: '16px',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '100%',
    height: '36px',
    paddingLeft: '16px',
    paddingRight: '16px',
    fontSize: theme.size.base,
    color: '#1F1F1F',
    background: '#F5F6F8',
    outline: 'none',

    '&::placeholder': {
      fontSize: theme.size.base,
      color: '#8F8F8F'
    }
  },

  button: {
    borderRadius: '8px',
    width: '100%',
    fontSize: theme.size.base
  }
}))

export default useStyles
